import React, { Component } from 'react';
import { ngDeps } from '../../../common/utilities/ngDependencies';
import { reduxConnect } from '../../../common';
import { setJsonCookie, getJsonCookieByKey } from '../../../common/utilities/cookie';
import { getQueryParameterByName } from '../../../common/utilities/queryParameters';
import { dataLayer, utilities } from '@weatherbug/common';
import { serializeObjectToQueryStringParameters } from '../../../common/utilities/queryParameters';

const {
    getAdTargetingParameters
} = dataLayer.actions;

const minimumViewingSeconds = 3;
const videoSettingsCookie = 'videoSettingsCookie';
const { unitSystemsEnum } = utilities.units;

const adServer = 'appNexus';
const adSDK = 'JWPlayer';
const adType = 'video';

const mapStoreStateToProps = storeState => {
    const targetingParametersState = storeState.adTargetingParameters && storeState.adTargetingParameters.targetingParameters || {};
    const appState = storeState.appState && storeState.appState.appState || {};
    const station = appState.user && appState.user.ActiveLocation && appState.user.ActiveLocation.Station || {};
    const locality = appState.locality || {};
    const units = unitSystemsEnum[storeState.units.unitSystem];
    const {
        authId,
        secret,
        adTargetingBaseUrl,
        stdParameters,
        videoAdRules,
        videoPrerollAdClient,
        videoPrerollOffset,
        videoPrerollSkipOffset,
        videoPrerollVPaidControls,
        videoPrerollAutoplayAdsMuted,
        busDomain,
        pageName
    } = appState;
    return {
        complianceRequirements: storeState.legal.complianceRequirements,
        adTargetingParameters: targetingParametersState.tp,
        latitude: locality.Latitude,
        longitude: locality.Longitude,
        region: locality.Dma,
        city: locality.CityName,
        state: locality.TerritoryAbbr,
        country: locality.CountryShortName,
        zip: locality.PostalCode,
        stdParameters,
        videoAdRules,
        authId,
        secret,
        adTargetingBaseUrl,
        stationId: station.StationId,
        providerId: station.ProviderId,
        adTargetingError: targetingParametersState.lastError,
        units,
        videoPrerollAdClient,
        videoPrerollOffset,
        videoPrerollSkipOffset,
        videoPrerollVPaidControls,
        videoPrerollAutoplayAdsMuted,
        busDomain,
        pageName
    };
};

const mapDispatchToProps = {
    getAdTargetingParameters
};

@reduxConnect(mapStoreStateToProps, mapDispatchToProps)
export class VideoPlayer extends Component
{
    static displayName = 'VideoPlayer';

    constructor(props)
    {
        super(props);
        this.lastVideoTimeLogged = 0;
        this.amountWatched = 0;
        this.componentMounted = false;
    }

    async componentDidMount()
    {
        if (this.props.complianceRequirements)
        {
            this.cookie = getJsonCookieByKey(videoSettingsCookie) || {
                muted: this.props.muteByDefault,
                volume: 90
            };
            this.trySetupVideoPlayer();
        }
    }

    componentWillUnmount()
    {
        if (this.videoPlayer)
        {
            this.videoPlayer.remove();
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.cookie) {
            this.cookie = getJsonCookieByKey(videoSettingsCookie) || {
                muted: this.props.muteByDefault,
                volume: 90
            };
        }

        if (!this.componentMounted && this.props.complianceRequirements)
        {
            this.trySetupVideoPlayer();
        }
        else if (   !this.componentMounted
                 && this.props.complianceRequirements
                 && this.props.playlist
                 && this.props.videoSources
        ) {
            this.trySetupVideoPlayer();
        }
        else if (
            this.props.videoSources !== prevProps.videoSources
            ||            this.props.playlist?.length !== prevProps.playlist?.length

            ||            this.componentMounted && (
                !this.videoPlayer
                    || this.props.videoUrl       !== prevProps.videoUrl
                    || this.props.posterImageUrl !== prevProps.posterImageUrl
                    || this.props.adPageId       !== prevProps.adPageId
                    || this.props.platformCode   !== prevProps.platformCode
            )
            
        )
        {
            //TODO: Should probably change this to only call setup video player for the first time and to otherwise just load new playlist in if those props change.
            this.trySetupVideoPlayer();
        }
    }

    trySetupVideoPlayer() {
        const { adTargetingBaseUrl,
            authId,
            secret,
            stdParameters,
            latitude,
            longitude,
            stationId,
            providerId,
            adTargetingParameters,
            videoUrl,
            posterImageUrl,
            adUrl,
            platformCode,
            videoSources,
            playlist,
            complianceRequirements,
            adTargetingError,
            region,
            city,
            state,
            country,
            zip,
            units,
            videoAdRules,
            videoPrerollAdClient,
            videoPrerollOffset,
            videoPrerollSkipOffset,
            videoPrerollVPaidControls,
            videoPrerollAutoplayAdsMuted
        } = this.props;
        if (!adTargetingParameters || adTargetingError) {
            if (adUrl
            && adTargetingBaseUrl
            && authId
            && secret
            && stdParameters
            && latitude
            && longitude) {
                this.props.getAdTargetingParameters(adTargetingBaseUrl,
                    authId,
                    secret,
                    false,
                    stdParameters,
                    latitude,
                    longitude,
                    stationId || '',
                    providerId || '',
                    adServer,
                    units);
            }
            return;
        }

        let adUrlWithTargeting;

        if (adUrl) {
            const adKeywords = { ...adTargetingParameters,
                latitude,
                longitude,
                region,
                city,
                state,
                country,
                zip
            };

            adUrlWithTargeting = serializeObjectToQueryStringParameters(adUrl,
                adKeywords);
        }

        this.setupVideoPlayer(
            videoUrl,
            posterImageUrl,
            adUrlWithTargeting,
            platformCode,
            videoSources,
            playlist,
            complianceRequirements,
            videoAdRules,
            videoPrerollAdClient,
            videoPrerollOffset,
            videoPrerollSkipOffset,
            videoPrerollVPaidControls,
            videoPrerollAutoplayAdsMuted
        );
        this.componentMounted = true;
    }

    setupVideoPlayer(
        videoUrl,
        posterImageUrl,
        adUrl,
        platformCode,
        videoSources,
        playlist,
        complianceRequirements,
        videoAdRules,
        videoPrerollAdClient,
        videoPrerollOffset,
        videoPrerollSkipOffset,
        videoPrerollVPaidControls,
        videoPrerollAutoplayAdsMuted
    )
    {        const { _Config } = ngDeps;
        let advertising = {};

        let platformAdsEnabled = true;
        if (platformCode)
        {
            var nav = _Config.Platform[platformCode].Ads;
            if (nav === 'False')
            {
                platformAdsEnabled = false;
            }
        }

        if (adUrl
            && (complianceRequirements && !complianceRequirements.disableAds)
            && !_Config.DisableAds
            && platformAdsEnabled
        )
        {
            const adId = getQueryParameterByName('id', adUrl);
            const adscheduleid = adId ? `wb${adId.padStart(8, '0')?.substring(2, adId.length)}` : 'wb123456';
            const frequencyAdRule = videoAdRules?.find(x => x.frequency) || {};

            advertising = {
                adscheduleid,
                client:  videoPrerollAdClient || 'vast',
                rules: {
                    frequency: frequencyAdRule.frequency, 
                    startOn: 0
                },
                schedule: {
                    pre: {
                        offset: videoPrerollOffset,
                        skipoffset: videoPrerollSkipOffset,
                        tag: adUrl,
                        vpaidcontrols: videoPrerollVPaidControls,
                        autoplayadsmuted: videoPrerollAutoplayAdsMuted
                    }
                }
            };

        }

        const cfg = {
            file: videoUrl,
            image: posterImageUrl,
            autostart: 'viewable',
            mute: this.cookie && this.cookie.muted || false,
            advertising,
            sources: videoSources,
            playlist,
            volume: this.cookie && this.cookie.volume
        };
        this.videoPlayer = window.jwplayer('wbVideo').setup(cfg);

        this.videoPlayer.on('mute', mute=>{
            this.changeMute(mute.mute);
        });

        this.videoPlayer.on('volume', (volume)=>{
            this.changeVolume(volume.volume);
        });

        if (this.props.playlistNextCallback)
        {
            this.videoPlayer.on('playlistItem', ({ index, item }) => {
                this.props.playlistNextCallback(index, item);
            });
        }

        this.videoPlayer.on('play', () => {
            if (this.seekJustOccurred)
            {
                this.seekJustOccurred = false;
            }
            else
            {
                const currentVideo = this.getCurrentVideo();
                if (this.currentVideo !== currentVideo)
                {
                    if (this.currentVideo && this.props.onPause)
                    {
                        this.props.onPause(this.currentVideoMetadata);
                    }
                    this.completeVideoAndClearData();
                    this.currentVideo = currentVideo;
                    this.currentVideoTitle = currentVideo.title;
                    this.currentVideoMetadata = this.getCurrentVideoMetadata();
                    if (this.props.onVideoStarted)
                    {
                        this.props.onVideoStarted(this.currentVideoMetadata);
                    }
                }
            }
        });

        if (this.props.onPause)
        {
            this.videoPlayer.on('pause', () => {
                this.props.onPause(this.currentVideoMetadata);
            });
        }

        if (this.props.onStop)
        {
            this.videoPlayer.on('idle', () => {
                this.props.onStop(this.currentVideoMetadata);
            });
            this.videoPlayer.on('remove', () => {
                this.props.onStop(this.currentVideoMetadata);
            });
        }

        this.videoPlayer.on('time', event => {
            this.onTime(event.currentTime);
        });

        this.videoPlayer.on('seek', event => {
            this.onSeek(event.offset);
        });

        if (this.props.onVideoCompleted)
        {
            this.videoPlayer.on('complete', event => {
                if (this.videoViewLogged)
                {
                    this.props.onVideoCompleted(this.currentVideoMetadata);
                }

                this.completeVideoAndClearData();
                this.currentVideo = null;
                this.currentVideoTitle = null;
            });
        }
    }

    changeMute(muted) {
        this.cookie.muted = muted;
        setJsonCookie(videoSettingsCookie, this.cookie, 10950);
    }

    changeVolume(volume) {
        this.cookie.volume = volume;
        setJsonCookie(videoSettingsCookie, this.cookie, 10950);
    }

    completeVideoAndClearData()
    {
        if (this.currentVideo)
        {
            this.lastVideoTimeLogged = 0;
            this.videoViewLogged = false;
            this.amountWatched = 0;
        }
    }

    onSeek(newCurrentTime)
    {
        this.lastVideoTimeLogged = newCurrentTime;
        this.seekJustOccurred = true;
    }

    onTime(currentVideoTime)
    {
        this.amountWatched += currentVideoTime - this.lastVideoTimeLogged;
        this.lastVideoTimeLogged = currentVideoTime;

        if (!this.videoViewLogged && this.amountWatched >= minimumViewingSeconds)
        {
            if (this.props.onVideoViewed)
            {
                this.props.onVideoViewed(this.getCurrentVideoMetadata());
            }
            this.videoViewLogged = true;
        }
    }

    getCurrentVideo()
    {
        return this.videoPlayer.getPlaylistItem(
            this.videoPlayer.getPlaylistIndex()
        );
    }

    getCurrentVideoMetadata()
    {
        const currentVideo   = this.getCurrentVideo();
        const currentQuality = currentVideo.sources[this.videoPlayer.getCurrentQuality()];

        return {
            id: currentVideo.mediaid,
            title: currentVideo.title,
            duration: this.videoPlayer.getDuration(),
            resolution: currentQuality && currentQuality.label,
            currentPosition: this.videoPlayer.getPosition(),
            cumulativeSecondsWatched: this.amountWatched
        };
    }

    render() {
        return (
            <div style={{ ...styles.container, height: this.props.height, width: this.props.width }}>
                <div id='wbVideo' ref={el => this.videoContainer = el} />
            </div>
        );
    }
}

const styles = {
    container: {
        display: 'flex'
    }
};
